export type ProfessionalScreeningLike = {
  id?: number;
  screening_type?: 'phone' | 'written' | string;
  reason?: string | null;
  canceled_at?: string | null;
  no_show?: boolean | null;
  scheduled_time?: string | null;
  screener_account_id?: number | null;
};

const toTime = (value?: string | null) => {
  if (!value) {
    return 0;
  }
  const time = new Date(value).getTime();
  return Number.isFinite(time) ? time : 0;
};

export const getLatestActivePhoneScreening = (
  record: any,
): ProfessionalScreeningLike | undefined => {
  const screenings: ProfessionalScreeningLike[] = record?.professional_screenings || [];
  const filtered = screenings
    .filter(
      (s) =>
        s?.screening_type === 'phone' &&
        s?.reason === 'application' &&
        !s?.canceled_at &&
        !s?.no_show &&
        !!s?.scheduled_time,
    )
    .sort((a, b) => toTime(b.scheduled_time) - toTime(a.scheduled_time));

  return filtered[0];
};

export const hasActivePhoneScreening = (record: any) => !!getLatestActivePhoneScreening(record);
